import { FC } from "react";
import { formatDate, formatTime } from "shared/utils";
import type { NotificationItem } from "../model/types";

import styles from "./NotificationRow.module.css";

interface Props {
  item: NotificationItem;
  onClick: (item: NotificationItem) => void;
}

export const NotificationRow: FC<Props> = ({ item, onClick }) => {
  const createdAt = Date.parse(item.created_at);

  return (
    <button
      type="button"
      className={`${styles.row} ${item.read ? "" : styles.unread}`}
      onClick={() => onClick(item)}
    >
      <span className={styles.title}>{item.title}</span>
      <span className={styles.body}>{item.body}</span>
      <span className={styles.date}>
        {formatDate(createdAt)} {formatTime(createdAt)}
      </span>
    </button>
  );
};
